<template>
  <div class="content">
    <router-link class="btn btn-secondary" :to="{ path: '/deals' }">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-left" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M15 8a.5.5 0 0 0-.5-.5H2.707l3.147-3.146a.5.5 0 1 0-.708-.708l-4 4a.5.5 0 0 0 0 .708l4 4a.5.5 0 0 0 .708-.708L2.707 8.5H14.5A.5.5 0 0 0 15 8z"/>
      </svg>
      Back to deals
    </router-link>

    <h4>{{ name }}</h4>

    <div class="row">
      <div class="form-group col-md-2">
        <div class="form-group">
          <label>Name</label>
          <b-input type="text"
                   v-model="deal.name"
                   v-on:input="changeDealName"/>
          <b-form-invalid-feedback :state="formErrors.name.state">{{ formErrors.name.message }}</b-form-invalid-feedback>
        </div>
      </div>

      <div class="form-group col-md-4">
        <label>Financial company (alias)</label>
        <v-select
          v-if="DDL['free_external_account']"
          label="name"
          key="key"
          :options="DDL.free_external_account"
          v-model="deal.external_account_alias"
          :reduce="option => option.id"
          :multiple="false"
          :clearSearchOnSelect="true"
          :closeOnSelect="true"
          :clearable="true"
          :disabled="!!deal.id"
          v-on:input="getGuaranteedBrokers"
        ></v-select>
        <b-form-invalid-feedback :state="formErrors.external_account_id.state">{{ formErrors.external_account_id.message }}</b-form-invalid-feedback>
      </div>

      <div class="form-group col-md-3" v-if="!deal.periodsExist">
        <label>Exclude weekends</label>
        <v-select
          v-if="DDL['weekends']"
          label="name"
          key="id"
          :options="DDL['weekends']"
          v-model="deal.weekend"
          :reduce="option => option.id"
          :multiple="false"
          :clearSearchOnSelect="true"
          :closeOnSelect="true"
          :clearable="true"
        ></v-select>
      </div>

      <div class="col-md-12">
        <h4>
          <b-form-invalid-feedback :state="formErrors.countries.state">{{ formErrors.countries.message }}</b-form-invalid-feedback>
        </h4>
      </div>
    </div>

    <div v-if="loading" style="text-align: center">
      <b-spinner style="text-align: center" variant="primary" label="Loading..."></b-spinner>
    </div>

    <div class="table-container">
      <b-table
        v-if="guaranteedBrokers"
        class="table-scroll"
        :fixed="true"
        :hover="true"
        :items="Object.keys(deal.countries)"
        :fields="tableFields"
        striped
      >
        <template v-slot:cell(broker)="row">
          {{getBrokerName(row.item).name}} (id: {{row.item}})
        </template>

        <template v-slot:head(countries)="row">
          Countries
          <b-form-invalid-feedback :state="formErrors.iso_code.state">{{ formErrors.iso_code.message }}</b-form-invalid-feedback>
        </template>

        <template v-slot:cell(countries)="row">
          <div v-for="(country, index) in deal.countries[row.item]">
            <div class="form-group">
              <v-select
                label="name"
                key="id"
                :options="DDL['country_iso']"
                v-model="deal.countries[row.item][index].iso_code"
                :multiple="false"
                :clearSearchOnSelect="true"
                :closeOnSelect="true"
                :clearable="true"
                :reduce="option => option.id"
                :disabled="country.pendingPeriodExist  === true"
                :style="{width: '250px'}"
              ></v-select>
            </div>
          </div>
        </template>

        <template v-slot:cell(p1)="row">
          <div v-for="(country, index) in deal.countries[row.item]">
            <div class="form-group">
              <v-select
                :options="DDL.p1"
                v-model="deal.countries[row.item][index].p1"
                :multiple="true"
                :clearSearchOnSelect="true"
                :closeOnSelect="false"
                :clearable="true"
                :disabled="country.pendingPeriodExist  === true"
                :style="{width: '250px'}"
              ></v-select>
            </div>
          </div>
        </template>

        <template v-slot:head(crg)="row">
          CRG
          <b-form-invalid-feedback :state="formErrors.crg.state">{{ formErrors.crg.message }}</b-form-invalid-feedback>
        </template>
        <template v-slot:cell(crg)="row">
          <div v-for="(country, index) in deal.countries[row.item]">
            <div class="form-group">
              <b-input type="number"
                      v-model="country.crg"
                      :disabled="country.pendingPeriodExist  === true"
                      :style="{width: '250px', height: '31px'}"
              />
            </div>
          </div>
        </template>
        <template v-slot:cell(actions)="row" v-slot:variant(info)>
          <div v-for="(country, index) in deal.countries[row.item]">
            <div class="form-group">
              <button class="btn btn-round btn-xs remove-country-btn"
                      :disabled="country.pendingPeriodExist  === true"
                      @click="removeCountryFromBroker(row.item, index)">
                <i class="nc-icon nc-simple-remove"></i>
              </button>
            </div>
          </div>
          <button class="btn btn-info" @click="addCountryToBroker(row.item)">Add country</button>
        </template>
      </b-table>
    </div>
    <div class="btn-group col-md-12">
      <div class="btn-group mr-2">
        <button class="btn btn-success" @click="saveDeal">Save</button>
      </div>
      <div class="btn-group mr-2">
        <b-button class="btn btn-warning"
        :to="{ path: `/deals/` }">Cancel</b-button>
      </div>
    </div>

  </div>
</template>

<script>
import API from "../api/Api";

export default {
  data() {
    return {
      deal: {
        name: "",
        external_account_id: null,
        weekend: false,
        periodsExist: false,
        countries: {},
      },
      name: String,
      DDL: {},
      loading: false,
      formErrors: {
        name: {state: false, message: null},
        external_account_id: {state: false, message: null},
        weekend: {state: false, message: null},
        countries: {state: false, message: null},
        iso_code: {state: false, message: null},
        crg: {state: false, message: null},
      },
      guaranteedBrokers: [],
      tableFields: [
        {
          key: 'broker',
          sortable: false,
          label: 'Broker',
        },
        {
          key: 'countries',
          sortable: false,
          label: 'Countries',
        },
        {
          key: 'p1',
          sortable: false,
          label: 'P1',
        },
        {
          key: 'crg',
          sortable: false,
          label: 'CRG',
        },
        {
          key: 'actions',
          sortable: false,
          label: 'Actions',
        }
      ],
    }
  },

  mounted() {
    this.name = this.$route.name;

    this.loadDDL();

    if (this.$route.params.id) {
      const dealId = +this.$route.params.id;
      const routeQuery = this.getFilterParams();

      API.post(`/distribution/deals/index?page=${routeQuery.currentPage}&per-page=${routeQuery.perPage}`, routeQuery).then(data => {
        const _deal = data.data.find((item) => item.id === dealId);
        this.deal = _deal;
        this.deal.external_account_id = _deal.external_account.id;
        this.deal.external_account_alias = _deal.external_account.alias;
        this.getGuaranteedBrokers(this.deal.external_account_id);
      }).catch(e => this.error = e.message).finally(() => this.loading = false);
    }
  },

  methods: {
    loadDDL: function () {
      const ddl = {
        'weekends': [
          {id: 1, name: 'Exclude weekends'},
          {id: 0, name: 'All week'},
        ]
      }
      Promise.all([
        API.get('/distribution/deals/external-accounts').then(data => {
          ddl['free_external_account'] = data.data.map(item => {
            return {
              id: item['key'],
              name: item['alias'] || item['name'] || item['key']
            }
          })
        }),
        API.get('/distribution/deals/countries').then(data => ddl['country_iso'] = data.data),
        API.get('/dropdowns/p1').then(data => ddl['p1'] = data.data)
      ]).then(() => {
        this.DDL = ddl;
      });
    },

    getFilterParams: function() {
      const routeQuery = {
        currentPage: this.$route.query.currentPage,
        perPage: this.$route.query.perPage,
      };

      if (this.$route.query.country_iso) {
        if (Array.isArray(this.$route.query.country_iso)) {
          routeQuery['country_iso'] = this.$route.query.country_iso;
        } else {
          routeQuery['country_iso'] = [this.$route.query.country_iso];
        }
      }
      if (this.$route.query.external_account) {
        if (Array.isArray(this.$route.query.external_account)) {
          routeQuery['external_account'] = this.$route.query.external_account;
        } else {
          routeQuery['external_account'] = [this.$route.query.external_account];
        }
      }
      if (this.$route.query.status) {
        if (Array.isArray(this.$route.query.status)) {
          routeQuery['status'] = this.$route.query.status;
        } else {
          routeQuery['status'] = [this.$route.query.status];
        }
      }

      return routeQuery;
    },

    changeDealName: function () {
      this.formErrors.name = {state: false, message: ''}
    },

    getGuaranteedBrokers: function (id) {
      this.guaranteedBrokers = [];

      if (id) {
        this.loading = true;
        API.get(`/distribution/deals/external-account-guaranteed/${id}`).then(data => {
          this.guaranteedBrokers = data.data;

          if (!this.deal.id) {
            this.deal.countries = {};
          }

          if (!this.deal.external_account_id) {
            this.deal.external_account_id = id;
          }

          this.formErrors.external_account_id = {state: false, message: null};

          data.data.forEach((broker) => {
            if (!this.deal.countries.hasOwnProperty(broker.id)) {
              this.$set(this.deal.countries, broker.id, []);
            }
          })
          this.loading = false;
        });
      } else {
        this.deal.countries = {};
      }
    },

    addCountryToBroker: function(id) {
      let countryIndex = this.deal.countries[id].length;
      this.$set(this.deal.countries[id], countryIndex, {iso_code: '', p1: [], crg: null})
    },

    removeCountryFromBroker: function (id, index) {
      this.deal.countries[id].splice(index, 1);
    },

    change: function (e, brokerId, countryIndex) {
      if (!e) return
      const deal = Object.assign({}, this.deal);
      deal.countries[brokerId][countryIndex].iso_code = e;
      this.deal = deal;
    },

    getBrokerName: function(id) {
      return this.guaranteedBrokers.find((item) => item.id === id) || {name: id};
    },

    saveDeal: function () {
      this.flushErrors();

      let postData = {
        name: this.deal.name,
        external_account_id: this.deal.external_account_id,
        weekend: this.deal.weekend,
        countries: this.deal.countries
      };

      const request = this.deal.id ? API.put(`/distribution/deals/${this.deal.id}`, postData) : API.post('/distribution/deals', postData);
      request.then(() => {
        this.$notifications.notify(
          {
            message: `${this.deal.name} success saved`,
            icon: 'nc-icon nc-app',
            horizontalAlign: 'right',
            verticalAlign: 'top',
            type: 'success'
          });
        this.$router.push('/deals')
      }).catch(e => {
        if (e.response && e.response.status === 422) {
          for (const error of e.response.data) {
            this.formErrors[error.field] = {state: false, message: error.message};
            window.scrollTo(0,0);
          }
        } else {
          this.$notifications.notify(
            {
              message: `Something went wrong. Cant save entity with error: ${e.message}`,
              icon: 'nc-icon nc-app',
              horizontalAlign: 'right',
              verticalAlign: 'top',
              type: 'danger'
            });
        }
      });
    },

    flushErrors: function () {
      for (const field in this.formErrors) {
        if (this.formErrors.hasOwnProperty(field)) {
          this.formErrors[field] = {state: null, message: null};
        }
      }
    },
  }
}
</script>

<style lang="scss" scoped>
/deep/ .vs--disabled .vs__dropdown-toggle,
/deep/ .vs--disabled .vs__clear,
/deep/ .vs--disabled .vs__search,
/deep/ .vs--disabled .vs__selected,
/deep/ .vs--disabled .vs__open-indicator {
  background-color: lightgray;
  color: gray;
}
.remove-country-btn {
  vertical-align: middle;
  margin: 5px 0 2px;
  &[disabled=disabled] {
    opacity: 0.1;
  }
}
.remove-country-btn i {
  font-weight: 900;
  font-size: 16px;
  vertical-align: middle;
}
/deep/ .vs__dropdown-option--selected {
  background-color: #aaaaaa;
}
</style>
